import { Step } from "react-joyride";

export const tourStepsMilestones = (): Step[] => {
  const steps: Step[] = [
    {
      target: "h1.milestones-heading",
      content:
        "Teachers set practice goals for a class. Students join with a code and earn a badge when they hit a goal.",
      disableBeacon: true,
    },
    {
      target: ".classroom-or-join-section",
      content:
        "Teachers create a class and share the code. Students enter that code here to join.",
    },
    {
      target: ".milestones-list-section",
      content:
        "Goals use real session stats: sessions finished, items practiced, a fast finish, or few missed items.",
    },
  ];

  return steps;
};
